import { units } from '@ui/css';
import { combineTokens, makeSelectors } from '@utils/css';

const tokens = combineTokens("--input", {
  width: "100%",
  fontSize: units.px(18)
});
const wrapper = "_35sw1wj0qk2";
const input = "_35siz4mxco";
const pencil = "_35sp1ogujjc";
const icon = "_35si19q61qf";
makeSelectors({
  wrapper,
  input,
  pencil
});

export { icon, input, pencil, tokens, wrapper };
import "./atom.text-input.style.linaria.module.css";
//# sourceMappingURL=atom.text-input.style.js.map
